import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=13c4ff89&scoped=true&"
import script from "./SignIn.vue?vue&type=script&lang=ts&"
export * from "./SignIn.vue?vue&type=script&lang=ts&"
import style0 from "./SignIn.vue?vue&type=style&index=0&id=13c4ff89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4ff89",
  null
  
)

export default component.exports